import React from 'react';
import { Placeholder } from './StyledComponents';
import SearchIcon from 'components/Icons/search';

interface ISearchPlaceholder {
  description: string;
}

export const SearchPlaceholder: React.FC<ISearchPlaceholder> = ({ description }) => {
  return (
    <Placeholder>
      <SearchIcon />
      <span>{description}</span>
    </Placeholder>
  );
};
